enum MissingAnswersResolutionType {
  SKIPPED,
  MARKED_NOT_DONE,
  ENTERED_PROGRESS_NOTE,
}

export default MissingAnswersResolutionType;
